import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import { IPermissionsGuard, TIsPermissionGranded } from './types';

/**
 * Will redirect if user has no permissions to acces to this route
 * Permissions are taken from user.permissions
 *
 * All permissions has a name and all of the crud instances (create | read | update | delete)
 *
 * Example:
 * LEAD_AUTH: { create: true, read: true, update: true, delete: true }
 *
 * @param {IPermissionsGuard} {
 *     children, Component of the view that will be shown
 *     permission, Name of the permissión that is required
 *     crud, Permission that route needs (create | read | update | delete)
 * }
 * @return {*}
 */
export const PermissionsGuard = ({
    children,
    roles,
    ...rest
}: IPermissionsGuard) => {
    const { user } = useAuth();
    const history = useHistory();
    const { permission, crud } = roles;

    const [permissionGranted, setPermissionGranted] =
        useState<TIsPermissionGranded>({
            loading: false,
            granted: false,
        });

    const { granted, loading } = permissionGranted;
    const isUserLoaded = !!user?._id;

    const handlePermissions = () => {
        const response = isPermissionGranted({
            permissions: user?.permissions || {},
            permission,
            crud,
        });

        setPermissionGranted({
            loading: true,
            granted: response,
        });
    };

    useEffect(() => {
        if (isUserLoaded) handlePermissions();
    }, [user]);

    if (loading && !granted) return history.push('/');

    if (isUserLoaded && granted) return <Fragment>{children}</Fragment>;
};
